/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { US_PreFilter } from "../models/us_pre-filter";
import { PreFilterDataUploadResult } from "../models/pre-filter-data-upload-result";
import { PreFilter } from "../models/pre-filter";
import { UpdateSharingStatus } from "../models/update-sharing-status";
import { ResolvedFilters } from "../models/resolved-filters";
@Injectable({
  providedIn: "root",
})
class PreFilterService extends __BaseService {
  static readonly preFilterGetPreFilterByIdPath =
    "/api/PreFilter/GetPreFilterById";
  static readonly preFilterGetPartnerEmbedPreFilterPath =
    "/api/PreFilter/GetPartnerEmbedPreFilter";
  static readonly preFilterGetPartnerEmbedPreFilterByApiKeyPath =
    "/api/PreFilter/GetPartnerEmbedPreFilterByApiKey";
  static readonly preFilterGetSubscriptionPreFiltersPath =
    "/api/PreFilter/GetSubscriptionPreFilters";
  static readonly preFilterProcessPreFilterTemplatePath =
    "/api/PreFilter/ProcessPreFilterTemplate";
  static readonly preFilterCreatePreFilterPath =
    "/api/PreFilter/CreatePreFilter";
  static readonly preFilterUpdatePreFilterPath =
    "/api/PreFilter/UpdatePreFilter";
  static readonly preFilterSetPreFilterDefaultPath =
    "/api/PreFilter/SetPreFilterDefault";
  static readonly preFilterDeletePreFilterPath =
    "/api/PreFilter/DeletePreFilter";
  static readonly preFilterDeletePreFilterByidPath =
    "/api/PreFilter/DeletePreFilterById";
  static readonly preFilterUpdatePreFilterSharingPath =
    "/api/PreFilter/UpdatePreFilterSharing";
  static readonly preFilterDeletePreFilterByEmbedPath =
    "/api/PreFilter/DeletePreFilterByEmbed";
  static readonly preFilterTypeExportsPath = "/api/PreFilter/TypeExports";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * @param preFilterId undefined
   */
  preFilterGetPreFilterByIdResponse(
    preFilterId?: number
  ): __Observable<__StrictHttpResponse<US_PreFilter>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (preFilterId != null)
      __params = __params.set("preFilterId", preFilterId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetPreFilterById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<US_PreFilter>;
      })
    );
  }
  /**
   * @param preFilterId undefined
   */
  preFilterGetPreFilterById(preFilterId?: number): __Observable<US_PreFilter> {
    return this.preFilterGetPreFilterByIdResponse(preFilterId).pipe(
      __map((_r) => _r.body as US_PreFilter)
    );
  }

  /**
   * @param partnerEmbedId undefined
   */
  preFilterGetPartnerEmbedPreFilterResponse(
    partnerEmbedId?: number
  ): __Observable<__StrictHttpResponse<US_PreFilter>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (partnerEmbedId != null)
      __params = __params.set("partnerEmbedId", partnerEmbedId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetPartnerEmbedPreFilter`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<US_PreFilter>;
      })
    );
  }
  /**
   * @param partnerEmbedId undefined
   */
  preFilterGetPartnerEmbedPreFilter(
    partnerEmbedId?: number
  ): __Observable<US_PreFilter> {
    return this.preFilterGetPartnerEmbedPreFilterResponse(partnerEmbedId).pipe(
      __map((_r) => _r.body as US_PreFilter)
    );
  }

  /**
   * @param partnerEmbedApiKey undefined
   */
  preFilterGetPartnerEmbedPreFilterByApiKeyResponse(
    partnerEmbedApiKey?: string
  ): __Observable<__StrictHttpResponse<US_PreFilter>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (partnerEmbedApiKey != null)
      __params = __params.set(
        "partnerEmbedApiKey",
        partnerEmbedApiKey.toString()
      );
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetPartnerEmbedPreFilterByApiKey`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<US_PreFilter>;
      })
    );
  }
  /**
   * @param partnerEmbedApiKey undefined
   */
  preFilterGetPartnerEmbedPreFilterByApiKey(
    partnerEmbedApiKey?: string
  ): __Observable<US_PreFilter> {
    return this.preFilterGetPartnerEmbedPreFilterByApiKeyResponse(
      partnerEmbedApiKey
    ).pipe(__map((_r) => _r.body as US_PreFilter));
  }

  /**
   * @param subscriptionId undefined
   */
  preFilterGetSubscriptionPreFiltersResponse(
    subscriptionId?: number
  ): __Observable<__StrictHttpResponse<Array<US_PreFilter>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subscriptionId != null)
      __params = __params.set("subscriptionId", subscriptionId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetSubscriptionPreFilters`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<US_PreFilter>>;
      })
    );
  }
  /**
   * @param subscriptionId undefined
   */
  preFilterGetSubscriptionPreFilters(
    subscriptionId?: number
  ): __Observable<Array<US_PreFilter>> {
    return this.preFilterGetSubscriptionPreFiltersResponse(subscriptionId).pipe(
      __map((_r) => _r.body as Array<US_PreFilter>)
    );
  }

  /**
   * @param templateFile undefined
   */
  preFilterProcessPreFilterTemplateResponse(
    templateFile?: null | Blob
  ): __Observable<__StrictHttpResponse<PreFilterDataUploadResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (templateFile != null) {
      __formData.append("templateFile", templateFile as string | Blob);
    }
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/ProcessPreFilterTemplate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PreFilterDataUploadResult>;
      })
    );
  }
  /**
   * @param templateFile undefined
   */
  preFilterProcessPreFilterTemplate(
    templateFile?: null | Blob
  ): __Observable<PreFilterDataUploadResult> {
    return this.preFilterProcessPreFilterTemplateResponse(templateFile).pipe(
      __map((_r) => _r.body as PreFilterDataUploadResult)
    );
  }

  /**
   * @param preFilter undefined
   */
  preFilterCreatePreFilterResponse(
    preFilter: PreFilter
  ): __Observable<__StrictHttpResponse<PreFilter>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = preFilter;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/CreatePreFilter`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PreFilter>;
      })
    );
  }
  /**
   * @param preFilter undefined
   */
  preFilterCreatePreFilter(preFilter: PreFilter): __Observable<PreFilter> {
    return this.preFilterCreatePreFilterResponse(preFilter).pipe(
      __map((_r) => _r.body as PreFilter)
    );
  }

  /**
   * @param preFilter undefined
   */
  preFilterUpdatePreFilterResponse(
    preFilter: PreFilter
  ): __Observable<__StrictHttpResponse<PreFilter>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = preFilter;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/UpdatePreFilter`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PreFilter>;
      })
    );
  }
  /**
   * @param preFilter undefined
   */
  preFilterUpdatePreFilter(preFilter: PreFilter): __Observable<PreFilter> {
    return this.preFilterUpdatePreFilterResponse(preFilter).pipe(
      __map((_r) => _r.body as PreFilter)
    );
  }

  /**
   * @param preFilterId undefined
   */
  preFilterSetPreFilterDefaultResponse(
    preFilterId: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = preFilterId;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/SetPreFilterDefault`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param preFilterId undefined
   */
  preFilterSetPreFilterDefault(preFilterId: number): __Observable<Blob> {
    return this.preFilterSetPreFilterDefaultResponse(preFilterId).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param preFilter undefined
   */
  preFilterDeletePreFilterResponse(
    preFilter: PreFilter
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = preFilter;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/DeletePreFilter`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param preFilter undefined
   */
  preFilterDeletePreFilter(preFilter: PreFilter): __Observable<Blob> {
    return this.preFilterDeletePreFilterResponse(preFilter).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param preFilterId undefined
   */
  preFilterDeletePreFilterByidResponse(
    preFilterId?: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (preFilterId != null)
      __params = __params.set("preFilterId", preFilterId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/DeletePreFilterById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param preFilterId undefined
   */
  preFilterDeletePreFilterByid(preFilterId?: number): __Observable<Blob> {
    return this.preFilterDeletePreFilterByidResponse(preFilterId).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param params The `PreFilterService.PreFilterUpdatePreFilterSharingParams` containing the following parameters:
   *
   * - `updateSharingStatus`:
   *
   * - `userId`:
   *
   * - `preFilterId`:
   */
  preFilterUpdatePreFilterSharingResponse(
    params: PreFilterService.PreFilterUpdatePreFilterSharingParams
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.updateSharingStatus;
    if (params.userId != null)
      __params = __params.set("userId", params.userId.toString());
    if (params.preFilterId != null)
      __params = __params.set("preFilterId", params.preFilterId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/UpdatePreFilterSharing`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param params The `PreFilterService.PreFilterUpdatePreFilterSharingParams` containing the following parameters:
   *
   * - `updateSharingStatus`:
   *
   * - `userId`:
   *
   * - `preFilterId`:
   */
  preFilterUpdatePreFilterSharing(
    params: PreFilterService.PreFilterUpdatePreFilterSharingParams
  ): __Observable<boolean> {
    return this.preFilterUpdatePreFilterSharingResponse(params).pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param partnerEmbedId undefined
   */
  preFilterDeletePreFilterByEmbedResponse(
    partnerEmbedId?: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (partnerEmbedId != null)
      __params = __params.set("partnerEmbedId", partnerEmbedId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/DeletePreFilterByEmbed`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param partnerEmbedId undefined
   */
  preFilterDeletePreFilterByEmbed(partnerEmbedId?: number): __Observable<Blob> {
    return this.preFilterDeletePreFilterByEmbedResponse(partnerEmbedId).pipe(
      __map((_r) => _r.body as Blob)
    );
  }
  preFilterTypeExportsResponse(): __Observable<
    __StrictHttpResponse<ResolvedFilters>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/TypeExports`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResolvedFilters>;
      })
    );
  }
  preFilterTypeExports(): __Observable<ResolvedFilters> {
    return this.preFilterTypeExportsResponse().pipe(
      __map((_r) => _r.body as ResolvedFilters)
    );
  }
}

module PreFilterService {
  /**
   * Parameters for PreFilterUpdatePreFilterSharing
   */
  export interface PreFilterUpdatePreFilterSharingParams {
    updateSharingStatus: Array<UpdateSharingStatus>;
    userId?: number;
    preFilterId?: number;
  }
}

export { PreFilterService };
